import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  Dashboard_Client_Report,
  Scrip_Search,
} from "../../Configuration/API_URL";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import $ from "jquery";
import { Client_Search } from "../../Configuration/API_URL";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
} from "../../CommonMethhods/CommonMethods";
import DividendTable from "../../Components/ReportTables/DividendTable";
import { Constants } from "../../CommonMethhods/Constants";
import FromdateComponent from "./FromdateComponent";
import TodateComponent from "./TodateComponent";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import DurationChangeComponent from "./DurationChangeComponent";
import { useDebounce } from "../../Components/useDebounce";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function DividendSidebar() {
  const storeToken = localStorage.getItem("ssoToken");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [checkDate, setCheckDate] = useState(false);
  const [clientNameError, setClientNameError] = useState(false);
  const [seg, setSeg] = useState("stocks");
  const [showEmailBtn, setShowEmailBtn] = useState(true);
  const [data, setData] = useState("");
  const [errorResp, setErrorResp] = useState("");
  const [nameError, setNameError] = useState("");
  const [page, setPage] = useState(1);
  const [scripPage, setScripPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [scroll, setScroll] = useState(false);
  const [clientName, setClientName] = useState("");
  const [scripName, setScripName] = useState("");
  const [isin, setIsin] = useState("");
  const [scripScroll, setScripScroll] = useState(false);
  const [clientCode, setClientCode] = useState("");
  const [serverError, setServerError] = useState("");
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [customShow, setCustomShow] = useState(false);
  const [selectDuration, setSelectDuration] = useState("");
  const [scripList, setScripList] = useState([]);
  const [scripLoader, setScripLoader] = useState(false);
  const [scriptotal, setScripTotal] = useState();
  const [show, setShow] = useState(false);
  const [showScrip, setShowScrip] = useState(false);

  const debouncedValue = useDebounce(clientName, 1000);
    useEffect(()=>{
      handleClientName(debouncedValue)
    }, [debouncedValue])

  const isinDebouncedVal = useDebounce(scripName, 1000);

  useEffect(()=>{
    handleScripName(isinDebouncedVal)
  }, [isinDebouncedVal])

  if (fromDate == "" || toDate == "") {
    const current = new Date();
    const CurrentYear = current.getFullYear();
    const CurrentMonth = current.getMonth();
    if (CurrentMonth < 4) {
      const newYear = `04-01-${CurrentYear - 1}`;
      const date = `${
        current.getMonth() + 1
      }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    } else {
      const newYear = `04-01-${CurrentYear}`;
      const date = `${
        current.getMonth() + 1
      }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    }
  }
  async function searchApiDetail(e) {
    $(".write-search.dividen").addClass("show-result scroll-table");
    let payloadValue = {
      keyword: e.toUpperCase(),
      Status: "",
      PageNo: page,
      PageSize: 10,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axiosInstance.post(
        Client_Search.Search_URL,
        `"${encPayload}"`,
      );

      const res = ApiResDecrypt(getSearchDetail?.data);

      if (res.message === "Client does not exist.") {
        setClientList([
          { clientname: "Client does not exist.", clientCode: null },
        ]);
      } else {
        if (scroll == true) {
          setClientList((prev) => {
            return [...prev, ...res.data.clients];
          });
          setServerError("");
        } else {
          setClientList(res.data.clients);
          setServerError("");
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setScrollLoader(false);
    }
  }

  async function searchScripApi(e, pageNo) {
    $(".write-search.dividen").addClass("show-result scroll-table");
    let payloadValue = {
      search: e,
      PageNo: pageNo,
      PageSize: 10,
    };
    console.log(payloadValue, "payloasValue");
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axiosInstance.post(
        Scrip_Search.Scrip_Search_URL,

        `"${encPayload}"`,
      );

      const res = ApiResDecrypt(getSearchDetail?.data);

      console.log(res, "resss");
      if (res.status === 0) {
        setScripTotal(res.data.totalCount);
        console.log(res.data.total);
        if (scripScroll == true) {
          setScripList((prev) => {
            return [...prev, ...res.data.scripNameList];
          });
          setServerError("");
        } else {
          setScripList(res.data.scripNameList);
          setServerError("");
        }
      } else {
        setScripList([{ scripName: "Scrip Name does not exist", isin: null }]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setScripLoader(false);
    }
  }

  function scripSet(name, isin, i) {
    if (name === "Scrip Name does not exist") {
      $(".write-search.dividen").addClass("show-result scroll-table");
    } else {
      $(".write-search.dividen").removeClass("show-result");
      setScripList([]);
      setScripName(name);
      setIsin(isin);
      setScripLoader(false);
    }
  }

  function clientSet(name, code, i) {
    if (name === "Client does not exist.") {
      $(".write-search.dividen").addClass("show-result scroll-table");
    } else {
      $(".write-search.dividen").removeClass("show-result");
      setClientList([]);
      setClientName(name);
      setClientCode(code);
      setScrollLoader(false);
    }
  }

  const handleClientName = (data) => {
    setShow(true);
    setShowScrip(false);
    setScrollLoader(false);
    setData("");
    setNameError("");
    if (data) {
      setClientList([]);
      setScroll(false);

      if (data?.length > 3) {
        setPage(1);
        setClientList([]);
        setScroll(false);
        searchApiDetail(data);
      }
    } else {
      setData("");
      setClientList([]);
      setPage(1);
      setClientName("");
      setClientCode("");
      setScroll(false);
      $(".write-search.dividen").removeClass("show-result");
    }
    $(".write-search.dividen-li").click(function () {
      $(".write-search.dividen").addClass("show-result scroll-table");
    });
  };

  const handleScripName = (data) => {
    setShow(false);
    setShowScrip(true);
    setScripLoader(false);
    setData("");
    setNameError("");

    if (data) {
      setScripList([]);
      setClientList([]);
      setScripScroll(false);
      // let value = e.target.value;
      // value = value.replace(/[^A-Z0-9 ]/gi, "");
      // value = value.replace(/\s{2,}/g, " ");
      // value = value.replace(/^\s+/, "");
      // setScripName(value);
      if (data?.length > 3) {
        setScripPage(1);
        setScripList([]);
        setScripScroll(false);
        searchScripApi(data, 1);
      }
    } else {
      setData("");
      setScripList([]);
      setScripPage(1);
      setScripName("");
      setIsin("");
      setScripScroll(false);
      $(".write-search.dividen").removeClass("show-result");
    }
    $(".write-search.dividen-li").click(function () {
      $(".write-search.dividen").addClass("show-result scroll-table");
    });
  };

  const handleScroll = async () => {
    setScroll(true);
    const a = document.querySelector("#dividend-scroll");
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
      setPage((prev) => prev + 1);
      setScrollLoader(true);

      searchApiDetail(clientName);
    }
  };

  const handleScripScroll = async (e) => {
    setScripScroll(true);
    console.log("entered scrip scroll");
    const el = e.target;
    const scrolledToBottom =
      el.scrollTop + el.offsetHeight + 1 >= el.scrollHeight;

    if (scrolledToBottom && !scripLoader) {
      console.log("in condition");
      const nextScripPage = scripPage + 1;

      console.log(scripPage, "page");
      const totalLoadedRecords = scripPage * 10;
      console.log(scriptotal);
      console.log(
        scriptotal > totalLoadedRecords,
        scriptotal !== scripList.length
      );
      if (scriptotal > totalLoadedRecords && scriptotal !== scripList.length) {
        setScripPage(nextScripPage);
        setScripLoader(true);
        searchScripApi(scripName, nextScripPage);
      } else {
        setScripLoader(false);
      }
    }
  };

  const getDividendReport = async (fileType) => {
    setLoader(true);
    if (fileType == "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
      setLoader(false);
    } else if (fileType == "pdf") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(true);
      setSmallLoaderMail(false);
      setLoader(false);
    } else if (fileType == "mail") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(true);
      setLoader(false);
    } else {
      setSmallLoaderMail(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    }
    let payloadValue = {
      clientCode: clientCode,
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileType,
      seg: seg,
      isin: isin,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.DividendReport_URL,
        `"${encPayload}"`,

      );
      const response = ApiResDecrypt(getDetails?.data);

      const res = response.data;
      if (res) {
        if (fileType == "grid") {
          setData(res?.divList);
        } else if (fileType == "excel") {
          window.open(res, "_self", "noopener,noreferrer");
        } else if (fileType == "pdf") {
          window.open(res, "_blank", "noopener,noreferrer");
        } else {
          toast.success("Mail sent successfully");
        }
      } else {
        setData([]);
        if (fileType == "excel") {
          toast.error("Dividend Report does not exist.");
        } else if (fileType == "pdf") {
          toast.error("Dividend Report does not exist.");
        } else if (fileType == "mail") {
          toast.error("Dividend Report does not exist.");
        }
      }
      setClientNameError(false);
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);

      setServerError("Something went wrong, Please try again later.");
      if (fileType == "excel") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType == "pdf") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType == "mail") {
        toast.error("Something went wrong, Please try again later.");
      }
    }
  };

  const handleOnClick = (e) => {
    const hasClient = clientName.length > 0;
    const hasScrip = scripName.length > 0;
    const hasDuration = Boolean(selectDuration);
    const hasValidDateRange =
      fromDate.trim().length > 0 &&
      toDate.trim().length > 0 &&
      compareDate(fromDate) &&
      compareDate(toDate) &&
      checkDateRange(fromDate, toDate);

    const hasValidName = hasClient || hasScrip;
    const isValidInputCombo = hasValidName && hasDuration;

    // Reset previous errors
    setClientNameError(false);
    setErrorResp("");

    if (!isValidInputCombo) {
      if (!hasValidName) {
        setClientNameError(true);
        setNameError("Please Enter valid Client Name or Scrip Name");
      } else if (!hasDuration) {
        setErrorResp("Please Select Duration");
      }
      return;
    }

    if (!e.target.value) return;

    if (!hasValidDateRange) {
      setCheckDate(true);
      setErrorResp("Please Select Correct Date");
      return;
    }

    // All validations passed
    getDividendReport(e.target.value);
  };

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  // const handleSegmentChange = (e) => {
  //   setData("");
  //   setFileType("");
  //   setSeg(e.target.value);
  // };

  const handleFromDateChange = (e) => {
    setData("");
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setErrorResp("");
    setServerError("");
  };
  const handleToDateChange = (e) => {
    setData("");
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setErrorResp("");
    setServerError("");
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const onChangeDuration = () => {
    setErrorResp("");
    setServerError("");
    setData("");
  };
  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box">
          <div>
            <h2 className="report-title">{Constants.Dividend_Report}</h2>
          </div>

          <div className="row input-field-wrapper">
            <div className="col-md-3 col-sm-4 col-12">
              <div className="form-group">
                <label className="form-label">{Constants.Client_Name}</label>
                <div className="input-text-wrapper align-items-center">
                  <input
                    id="input1"
                    type="text"
                    className="input-text form-control"
                    placeholder="Search by Name/ Code"
                    value={clientName}
                    onChange={(e) => {
                      setClientName(e?.target?.value?.toUpperCase())
                      // handleClientName(e);
                    }}
                    onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                  }}
                  />

                  <ul
                    className="write-search dividen border-0"
                    id="dividend-scroll"
                    onScroll={handleScroll}
                  >
                    {show &&
                      clientList.map((item, i) => (
                        <li
                          key={i}
                          onClick={() =>
                            clientSet(item.clientname, item.clientCode, i)
                          }
                        >
                          <div> {item.clientname}</div>
                          <div>{item.clientCode}</div>
                        </li>
                      ))}
                    {scrollLoader && (
                      <div className="loader-center">
                        <LoaderForSearch />
                      </div>
                    )}
                  </ul>
                </div>
                <span className="to-date-error" style={{ bottom: "-5px" }}>
                  {nameError}
                </span>
              </div>
            </div>

            <div className="col-md-3 col-sm-4 col-12">
              <div className="form-group">
                <label className="form-label">Scrip Name/ISIN:</label>
                <div className="input-text-wrapper align-items-center">
                  <input
                    id="input1"
                    type="text"
                    className="input-text form-control"
                    placeholder="Search by Scrip Name or ISIN"
                    value={scripName}
                    onChange={(e) => setScripName(e?.target?.value?.toUpperCase())
                      // handleScripName(e);
                    }
                    onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                  }}
                  />

                  <ul
                    className="write-search dividen border-0"
                    id="scrip-scroll"
                    onScroll={(e) => handleScripScroll(e)}
                  >
                    {showScrip &&
                      scripList.map((item, i) => (
                        <li
                          key={i}
                          onClick={() => scripSet(item.scripName, item.isin, i)}
                        >
                          <div>
                            <div>{item.isin}</div>
                            <div> {item.scripName}</div>
                          </div>
                        </li>
                      ))}
                    {scripLoader && (
                      <div className="loader-center">
                        <LoaderForSearch />
                      </div>
                    )}
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group">
                <DurationChangeComponent
                  setCustomShow={setCustomShow}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  onChangeDuration={onChangeDuration}
                  setSelectDuration={setSelectDuration}
                  selectDuration={selectDuration}
                />
              </div>
              {errorResp && !selectDuration && (
                <span className="duration-date-error">{errorResp}</span>
              )}
            </div>
            {customShow && (
              <div className="col-md-3 col-sm-4 col-12">
                <FromdateComponent
                  fromDate={handleFromDateChange}
                  formatDate={formatDate(fromDate)}
                  DateReverse={DateReverse}
                  clientWiseReportForCustomCalanderIcon={true}
                />
              </div>
            )}
            {customShow && (
              <div className="col-md-3 col-sm-4 col-12">
                <TodateComponent
                  toDate={handleToDateChange}
                  formatToDate={formatDate(toDate)}
                  DateReverse={DateReverse}
                  errorResponse={errorResp}
                  clientWiseReportForCustomCalanderIcon={true}
                />
              </div>
            )}
          </div>
          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
            >
              {Constants.Search}
            </button>
          </div>
          <div>
            {" "}
            <ReportTableHeader
              smallLoaderMail={smallLoaderMail}
              showEmailBtn={showEmailBtn}
              smallLoaderExcel={smallLoaderExcel}
              smallLoaderPdf={smallLoaderPdf}
              handleOnClick={handleOnClick}
            />
          </div>
          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : data && data ? (
              <div>
                <DividendTable data={data} seg={seg} />
              </div>
            ) : serverError ===
              "Something went wrong, Please try again later." ? (
              <h4 className="report-error-message">{serverError}</h4>
            ) : (
              ""
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default DividendSidebar;
